var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.375,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#662AB2",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 19.875C16.6667 20.5167 17.1667 21.0417 17.7751 21.0417H19.0251C19.5584 21.0417 19.9917 20.5833 19.9917 20.025C19.9917 19.4167 19.7251 19.2 19.3334 19.0583L17.3334 18.3583C16.9334 18.2167 16.6667 18 16.6667 17.3917C16.6667 16.8333 17.1001 16.375 17.6334 16.375H18.8834C19.5001 16.3833 20.0001 16.9 20.0001 17.5417",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 21.0833V21.6999",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 15.7166V16.3666",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3251 25.3584C22.0024 25.3584 24.9834 22.3774 24.9834 18.7001C24.9834 15.0228 22.0024 12.0417 18.3251 12.0417C14.6478 12.0417 11.6667 15.0228 11.6667 18.7001C11.6667 22.3774 14.6478 25.3584 18.3251 25.3584Z",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8167 26.9416C21.5667 27.9999 22.7917 28.6916 24.1917 28.6916C26.4667 28.6916 28.3166 26.8416 28.3166 24.5666C28.3166 23.1833 27.6333 21.9583 26.5917 21.2083",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestor);
export default __webpack_public_path__ + "static/media/investor.bff826e9d9746e1e0b6e007ad47e3fa8.svg";
export { ForwardRef as ReactComponent };